import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "../../MissionAndVission/MissioonSideCards/MissioonSideCards.css";
import "./WhatisSM.css";

const WhatisSM = () => {
  return (
    <>
      <div className="container safetyCardContainer mt-md-5">
        <div className="safetyCardBox mt-md-5 pt-md-4 mb-md-5">
          <div className="col-lg-6 col-md-6 col-sm-12 mt-xxl-4">
            <h1 className="headings mt-md-3  sm-heading">
              <span>Maximize </span>Efficiency with Strategic Account Management
            </h1>
            <p className="missionP-one smP-one mb-2 mb-md-4">
              Managing corporate travel is challenging, but Blueberry Travels is
              here to make it effortless. Our dedicated strategic account
              managers are here to create and implement customized travel
              programs designed to meet your business goals.
            </p>
            <p className="missionP-two">
              Whether it’s negotiating with vendors, handling program reporting,
              or ensuring day-to-day operations run smoothly, we take care of it
              all. By providing a personalized, hands-on approach, our account
              management team ensures your corporate travel experience is
              flawless, cost-effective, and aligned with your company’s specific
              needs and budget.
            </p>
          </div>

          <div className="col-lg-6 col-md-6 col-sm-12  mt-2 mt-lg-0 d-md-flex justify-content-md-center ms-lg-5 mt-md-0">
            <LazyLoadImage
              src="https://blueberrywebsites.azureedge.net/bbt/images/whatsm1.png"
              alt=""
              className="safetyTravelimg sm-images"
              loading="lazy"
            />
          </div>
        </div>

        <div className="safetyCardBoxReverse mt-md-5 pt-md-3 mb-md-5">
          <div className="col-lg-6 col-md-6 col-sm-12 mt-xxl-4">
            <h1 className="headings sm-heading">
              <span>Why</span> Strategic Account Management Matters for Your
              Business
              <span className="text-dark" style={{ fontWeight: "bold" }}>
                ?
              </span>
            </h1>
            <p className="missionP-one smP-one">
              Corporate travel should never disturb your operations. At
              Blueberry Travel, we make sure it doesn’t. Managing corporate
              travel can be overwhelming, like adjusting to shifting schedules,
              staying compliant with travel policies, and managing travel costs.
              Therefore, we understand these complexities and offer a solution
              that simplifies this challenge. Hence, our expert strategic
              account managers handle every detail—from last-minute
              cancellations and schedule changes to dealing with unforeseen
              circumstances.
            </p>
            <p className="missionP-two">
              Our goal is to ensure all travel policies are met so you can focus
              on growing your business. We guarantee efficiency, save you time
              and money, and enhance the overall travel experience for your
              employees.
            </p>
          </div>

          <div className="col-lg-6 col-md-6 col-sm-12 mt-2 mt-lg-0  d-md-flex justify-content-md-center me-xxl-5">
            <LazyLoadImage
              src="https://blueberrywebsites.azureedge.net/bbt/images/whatsm2.png"
              alt=""
              className="safetyTravelimg safetyTravelimg2 sm-images"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default WhatisSM;
